import React from 'react';
import { FormControlLabel, Switch as MUISwitch } from '@mui/material';

import { Props } from './props';

const SwitchView: React.FC<Props> = (props) => {
  const {
    value,
    label = 'Label',
    labelPlacement = 'end',
    switchProps,
    ...rest
  } = props;
  return (
    <FormControlLabel
      value={value}
      label={label}
      labelPlacement={labelPlacement}
      {...rest}
      control={<MUISwitch {...switchProps} checked={value} />}
    />
  );
};

export const Switch = SwitchView;
export default SwitchView;
